import type { CookingTimeTranslations } from './types';

interface StatusGuideProps {
  t: CookingTimeTranslations;
}

export function StatusGuide({ t }: StatusGuideProps) {
  const statuses = [
    { color: 'bg-secondary', label: t.quiet, description: t.statusDescriptions.quiet },
    { color: 'bg-primary', label: t.normal, description: t.statusDescriptions.normal },
    { color: 'bg-warning', label: t.peak, description: t.statusDescriptions.peak }
  ];

  return (
    <div className="p-[clamp(16px,4vw,24px)] pt-0">
      <div className="bg-muted p-[clamp(12px,3vw,16px)] rounded-[clamp(8px,2vw,12px)]">
        <h4 className="text-[clamp(12px,3vw,14px)] font-medium text-foreground mb-[clamp(8px,2vw,10px)]">
          {t.statusGuide}
        </h4>
        <div className="space-y-[clamp(4px,1vw,6px)]">
          {statuses.map(({ color, label, description }) => (
            <div key={label} className="flex items-center gap-[clamp(8px,2vw,10px)]">
              <div className={`w-[clamp(8px,2vw,10px)] h-[clamp(8px,2vw,10px)] ${color} rounded-full`} />
              <span className="text-[clamp(11px,2.75vw,13px)] text-foreground">
                {label}: {description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
